import { render } from "./Dashboard.vue?vue&type=template&id=6b2fd746&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=6b2fd746&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b2fd746"

export default script